<template>

	<div class="row navbar-wrapper" :class="{violet: isInUserSection, red: isOffline, yellow: yellowBar, manual: userStore.manualCode}">
		<div :class="{manual: userStore.manualCode, 'kitchen-section': isInKitchenSection}" class="navbar-content">
			<div v-if="!isInKitchenSection" :class="{semitransparent: !collapsedSidebar}" @click="clickHamburger()" class="hamburger-btn" v-html="getIcon('iconHamburger')"></div>
			<slot name="content"></slot>
		</div>
	</div>

	<div class="sidebar-wrapper" :class="{collapsed: collapsedSidebar}">
		<SidebarMacro @switched-item="switchMacro" />
		<div class="micro-sidebar-container" v-if="showMicroSidebar">
			<SidebarMicro v-if="sidebarItems && sidebarItems.length" is-micro class="top-border" ref="micro-sidebar" :base-path="basePath" :items="sidebarItems" @switched-item="switchedItem" @switched-child-item="switchedChildItem" />
		</div>
		<div class="overlay" @click="toggleSidebar"></div>
	</div>

</template>

<script>
import BusinessesSelect from "@/console-new/components/shared/BusinessesSelect.vue";
import SidebarMicro from "@/console-new/components/shared/SidebarMicro.vue";
import SidebarMacro from "@/console-new/components/shared/SidebarMacro.vue";

import {useSvgStore} from "@/shared/stores";
import {useUserStore, useMenuStore, useFunnelStore, useRoomsOrdersStore} from "@/console-new/stores";

export default {
	setup() {
		const svgStore = useSvgStore();
		const userStore = useUserStore();
		const roomsOrdersStore = useRoomsOrdersStore();
		const menuStore = useMenuStore();
		const funnelStore = useFunnelStore();
		return {
			getIcon: svgStore.get,
			userStore,
			menuStore,
			funnelStore,
			roomsOrdersStore,
		};
	},
	name: "TopNavbar",
	components: {BusinessesSelect, SidebarMicro, SidebarMacro},
	emits: ['switched-item', 'switched-child-item', 'clicked-hamburger'],
	data: function () {
		return {
			collapsedSidebar: false,
			firstCreation: true,
		}
	},
	props: {
		basePath: {
			type: String,
			required: true
		},
		sidebarItems: {
			type: Array,
			default: null,
			validator(value) {
				return value.every(item => item.name && item.icon && (item.path || item.beforeEmitFunction) && (!item.children || item.children.length > 0));
			}
		},
		isInUserSection: {
			type: Boolean,
			default: false
		},
		isInKitchenSection: {
			type: Boolean,
			default: false
		},
		showMicroSidebar: {
			type: Boolean,
			default: false
		},
		isOffline: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		yellowBar() {
			let yellowBar = false;

			if(this.$route.path.startsWith('/ops')) {
				yellowBar = !!this.roomsOrdersStore?.roomsTablesCallsNotViewed?.length;
			}
			else if(this.$route.path === '/config/administration/stripe') {
				yellowBar = this.userStore.mandatoryUserVerificationForBusiness();
			}

			return yellowBar;
		}
	},
	methods: {
		switchedItem(newItemIndex) {
			if(!this.sidebarItems[newItemIndex].children) {
				this.collapsedSidebar = true;
			}
			this.$emit('switched-item', newItemIndex);
		},
		switchedChildItem(newChildIndex) {
			this.collapsedSidebar = true;
			this.$emit('switched-child-item', newChildIndex);
		},
		toggleSidebar() {
			this.collapsedSidebar = !this.collapsedSidebar;
		},
		clickHamburger() {
			this.$emit('clicked-hamburger');
			this.toggleSidebar();
		},
		switchMacro() {
			this.collapsedSidebar = true;
		},
	},
	created() {
		if(firstOpen && !this.funnelStore.wentToShop && !this.menuStore.shouldCreateCategory) {
			this.switchMacro();
		} else {
			firstOpen = true;
			this.collapsedSidebar = true;
		}
		if(this.isInKitchenSection) {
			this.collapsedSidebar = true;
		}
	},
}

let firstOpen = false;
</script>
<style lang="scss">
 .navbar-content h3 {
	 font-size: 16px;
 }
</style>
<style lang="scss" scoped>
.navbar-wrapper {
	height: 100%;
	align-items: center;
	background-color: var(--color-bg-primary-2);

	&.manual {
		background-color: var(--color-manual-2);
	}

	.navbar-content {
		display: flex;
		align-items: center;
		width: 100%;
		height: 60px;

		&.manual {
			background-color: var(--color-manual-2);
		}
	}

	.hamburger-btn {
		@include centered;
		width: 40px;
		padding: 10px;
		cursor: pointer;
		display: none;
		transition: opacity .3s ease;

		:deep(svg) {
			width: 100%;
			height: 100%;

			.fill {
				fill: var(--color-svg-primary);
			}

			.stroke {
				stroke:var(--color-svg-primary);
			}
		}

		&.semitransparent {
			opacity: .2;
		}
	}

	&.violet {
		background-color: var(--navbar-user-color);
	}

	&.red {
		background-color: #e24b743b;
	}

	&.yellow:not(.violet):not(.red) {
		background-color: #FC750233;
	}

	@media (max-width: 920px) {
		padding-left: 0;

		.hamburger-btn {
			display: flex;
		}
		.navbar-content.kitchen-section {
			width: 100%;
		}
	}
	@media (max-width: 768px) {
		background-color: var(--color-bg-primary-2);
		align-items: flex-start;

		.navbar-content {
			background-color: var(--color-bg-primary-2);
			width: 100%;
		}

		&.violet {
			background-color: var(--navbar-user-color);

			&.always-show-business .navbar-content, .navbar-content {
				background-color: var(--color-bg);

				&:deep(.navbar-slot-content) {
					background-color: var(--color-alpha-2);
				}
			}
		}

		&.red {
			background-color: var(--color-bg-primary-2);

			&.always-show-business .navbar-content, .navbar-content {
				background-color: var(--color-bg);

				&:deep(.navbar-slot-content) {
					background-color: #e24b743b;
				}
			}
		}

		&.yellow:not(.violet):not(.red) {
			background-color: var(--color-bg-primary-2);

			&.always-show-business .navbar-content, .navbar-content {
				background-color: var(--color-bg);

				&:deep(.navbar-slot-content) {
					background-color: #FC750233;
				}
			}
		}
	}

}
.sidebar-wrapper {
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	display: none;
	transition: left .3s ease;
	z-index: 200;

	.micro-sidebar-container {
		width: 220px;
	}

	.overlay {
		position: absolute;
		width: calc(100% + 270px);
		height: 100%;
		background-color: var(--color-bg-overlay);
		backdrop-filter: blur(5px);
		-webkit-backdrop-filter: blur(5px);
		transition: opacity .3s ease;
		opacity: 1;
		z-index: -1;
	}

	@media (max-width: 920px) {
		display: flex;
	}

	&.collapsed {
		left: -270px;
		width: 270px;
		.overlay {
			width: 0;
			opacity: 0;
		}
	}

	.top-border {
		border-top: 1px solid var(--color-alpha-4);
	}
}
</style>